import { render, staticRenderFns } from "./PrintCouponsDeleteArchive.vue?vue&type=template&id=7844b181"
import script from "./PrintCouponsDeleteArchive.vue?vue&type=script&lang=js"
export * from "./PrintCouponsDeleteArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports